import { useContext } from "react";
import { SpecsContext } from "./SpecsContext";
import { DesignProduct } from "../../types";

export const useSpecs = () => {
  const { specs } = useContext(SpecsContext);

  const getProductVersion = (product: DesignProduct) => {
    const productSpecs = specs?.products.find((p) => p.name === product.name);
    const productVersion = productSpecs?.versions.find(
      (v) => v.name === product.version
    );
    return productVersion;
  };

  const getProductSize = (product: DesignProduct) => {
    const productSize = getProductVersion(product)?.sizes;
    return productSize;
  };

  const getProductDeliveryTime = (product: DesignProduct) => {
    const productDeliveryTime = getProductVersion(product)?.deliveryTime;
    return productDeliveryTime;
  };

  const getProductLine = (product: DesignProduct) => {
    const productLine = getProductVersion(product)?.productLine;
    return productLine;
  };

  return {
    specs,
    getProductVersion,
    getProductSize,
    getProductDeliveryTime,
    getProductLine,
  };
};
